module.exports = __webpack_public_path__ + "img/cover-image.380ff247.png";